import styled from "styled-components";

export const CountContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 4px;
  line-height: 20px;
`;
